import { h, Component } from 'preact';
import style from './style';

import { getTargetImageRes, sortNumericKeys } from '../../helper';

export default class GalleryImage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			zoom: false
		}
	}

	componentWillMount() {
		let images = this.props.images;
		let imageKeys = Object.keys(images);
		let actualIndex = this.props.index + 1;
		let availableRes = imageKeys.filter(item => parseInt(item.split('_')[0].substr(-1)) === actualIndex);
		let imageResolutions = sortNumericKeys(availableRes.map(item => item.split('_')[1]));
		
		this.targetRes = getTargetImageRes(imageResolutions);
	}

	render(props, state) {
		let image = `${this.props.images['img' + (this.props.index + 1) + `_${this.targetRes}`] || this.props.images['img' + (this.props.index + 1) + `_src`]}`;
		let imageContainerStyle = {
			width: '100%',
			height: '100%',
			position: 'relative',
			overflow: this.state.zoom ? 'scroll' : 'hidden',
			background: `url(${image}) no-repeat center center`,
			backgroundSize: props.imageSize || 'contain',
			backgroundColor: `${props.bgColor}B3` || '#fffff' // bg color alpha/opacity 70%
		};

		return (
			<div class={'swiper-slide'}>
				<div class={style.slideContainer}>
					<div class={'imageContainer'} style={imageContainerStyle} />
          {props.showOverlay? <div className="imgOverlay" /> : null}
				</div>
			</div>
		)
	}

	handleZoom() {
		this.setState({
			zoom: !this.state.zoom
		})
	}
}


// WEBPACK FOOTER //
// ./components/spareparts/galleryImage/index.js